import { nanoidGenerate } from '@yola/ws-sdk';

const alphabet = 'abcdefghijklmnopqrstuvwxyz';
const length = 10;

const generateAlphaId = () => nanoidGenerate(alphabet, length);

export default generateAlphaId;
